import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { of, Observable } from 'rxjs';
import { catchError, mapTo, tap, map } from 'rxjs/operators';
// import * as moment from 'moment';
// import * as moment_tz from 'node_modules/moment-timezone';

import axios from "axios";


@Injectable({ providedIn: 'root' })
export class ReportService {
    private defaultUrl: any;
    private defaultUrlControl: any;
    constructor(private http: HttpClient) {

        this.defaultUrl = axios.create({
            baseURL: environment.API
        });

        this.defaultUrlControl = axios.create({
            baseURL: environment.API_CONTROL
        });
    }

    /* GET Plot Detail by ID */

    // public getPlotDetailByID(id): Observable<any> {
    //     return this.http.get<any>(`${environment.API}${environment.URL_GET_DETAIL_PLOT_BY_ID}/${id}`)
    //         .pipe(
    //             catchError(error => {
    //                 return of(error.error);
    //             }));
    // }



    public getReportFlower(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_GET_REPORT_FLOWER}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public getReportFlowerPlot(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_GET_REPORT_FLOWER_PLOT}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }


    public getReportFlowerZone(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_GET_REPORT_FLOWER_ZONE}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public getReportPod(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_GET_REPORT_POD}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    
    public getReportPodZone(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_GET_REPORT_POD_ZONE}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    
    public getReportPodPlot(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_GET_REPORT_POD_PLOT}`, data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public getFarmList(): Observable<any> {
        return this.http.get<any>(`${environment.API}${environment.URL_GET_DROPDOWN_CHILDORG_FARM}`)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }
    

    public getPlotList(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_GET_LIST_PLOT}`,data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public getPoleList(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_GET_LIST_POLE}`,data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    public getZoneList(data): Observable<any> {
        return this.http.post<any>(`${environment.API}${environment.URL_GET_LIST_ZONE}`,data)
            .pipe(
                catchError(error => {
                    return of(error.error);
                }));
    }

    
}